/**
 * Turning a stored value into somewhere a browser can go.
 *
 * Pure, and the reason it exists is a security one rather than a formatting
 * one. A `url` field's validation on the backend is a single lenient
 * expression -- anything with no whitespace and a dot or a `//` in it -- so
 * `javascript://%0aalert(1)` is a value it stores, confirmed against the
 * running API. Rendered as an `href` that runs `alert(1)` on a click, from data
 * anybody who can write a row can put there.
 *
 * So the scheme is chosen here rather than taken from the value. Anything
 * outside the list below is prefixed as though it had none, which turns an
 * executable value into an inert and visibly wrong one instead of quietly
 * dropping the cell.
 */

/**
 * The schemes a stored value is followed under as it stands.
 *
 * An allow list rather than a list of the dangerous ones: `javascript` and
 * `vbscript` are the two anybody thinks of, and the next one is the reason a
 * block list is the wrong shape. `ftp` and friends earn their place because a
 * url field is a fair thing to keep one in.
 */
const FOLLOWED_AS_WRITTEN = /^(https?|ftps?|sftp|mailto|tel):/i

/** Where a url cell points, with a scheme it is safe to follow. */
export function urlHref(value: string): string {
  const written = value.trim()
  return FOLLOWED_AS_WRITTEN.test(written) ? written : `https://${written}`
}

/** Where an email cell points. */
export function emailHref(value: string): string {
  return `mailto:${encodeURI(value.trim())}`
}

/** Where a phone cell points. */
export function phoneHref(value: string): string {
  return `tel:${encodeURI(value.trim())}`
}
